import React from "react";
import "./FooterInfo.scss";

const FooterInfo = ({ themeOptions }) => {
    const { tel_1, tel_2, email, address } = themeOptions;

    return (
        <div className="footer-info">
            <div className="footer-info--heading">
                <h4>Zabierzmy się do pracy</h4>
                <p>
                    Jeśli masz jakieś pytania, zadzwoń do nas lub skorzystaj z formularza, <b>a otrzymasz bezpłatną wycenę</b>.
                </p>
            </div>
            <div className="footer-info--contact-data">
                {tel_1 && (
                    <div className="single-contact-data">
                        <span className="single-contact-data--icon phone-icon"></span>
                        <a href={`tel:${tel_1}`} className="single-contact-data--text">
                            {tel_1}
                        </a>
                    </div>
                )}
                {tel_2 && (
                    <div className="single-contact-data">
                        <span className="single-contact-data--icon phone-icon"></span>
                        <a href={`tel:${tel_2}`} className="single-contact-data--text">
                            {tel_2}
                        </a>
                    </div>
                )}
                {email && (
                    <div className="single-contact-data">
                        <span className="single-contact-data--icon envelope-icon"></span>
                        <a href={`mailto:${email}`} className="single-contact-data--text">
                            {email}
                        </a>
                    </div>
                )}
                {address && (
                    <div className="single-contact-data map-marker-icon">
                        <span className="single-contact-data--text">{address}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FooterInfo;
